import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import { translate } from 'react-i18next';


var ProductLong = React.createClass({

  getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },

    selectProduct(product) {
        let select_to_signup = true;


        if(select_to_signup) {
            var form = document.createElement('form');
            form.method = 'POST';
            form.action = this.state.store.get('signup_submit_target');

            var inputs = [
                ['referral_code', this.state.store.get('referralCode')],
                ['coupon_code', (product.promo && product.promo.code ? product.promo.code : '')],
                ['prequal_key', this.state.store.get('prequal_tracking_key')],
                ['product_key', product.product_key],
                ['coupon_history', (window.coupon_history ? window.coupon_history : []) ],
                ['sso_user', this.state.store.get('sso_user')],
                ['sonic_elq_customerID', this.state.store.get('sonic_elq_customerID')],
            ];
            inputs.forEach(function(v) {
                var input = document.createElement('input');
                input.type = 'hidden';
                input.name = v[0];
                input.value = v[1];

                form.append(input);
            })

            document.body.append(form);

            form.submit();
            AvailabilityActions.placeOrder();
        }

        AvailabilityActions.selectProduct(product);
    },

    render() {
        const { product, t, cardcolclasses, productsCount, show_voice_only, is_preorder_available } = this.props;
        var store = this.state.store;

        let flat_rate_available = store.get('fusion_fiber_data_flat_rate_available');
        let is_fusion_fiber_data_flat_rate = product.product_key.indexOf('fusion_fiber_data_flat_rate') !== -1;

        let hide_description = (flat_rate_available);
        let show_price_plus_taxes_fees = (flat_rate_available && !is_fusion_fiber_data_flat_rate);
        let replace_description_with_eero = (flat_rate_available && is_fusion_fiber_data_flat_rate);
        let show_price_as_flat_rate = (flat_rate_available && is_fusion_fiber_data_flat_rate);

        var recommendedRibbon;
        if(product && product.recommended) {
            let recommendedText = (is_fusion_fiber_data_flat_rate ? 'UPGRADED WIFI BUNDLE' : 'RECOMMENDED');
            recommendedRibbon = <div className="new-recommended-ribbon"><p>{recommendedText}</p></div>;
        }

        var displayPrice = parseFloat(product.mrc);

        let productRegularPrice = parseFloat(product.mrc);
        //forcing standard ipbb below to add rental fee to display price
        if(product.show_mrc_and_extra_fees_as_flat_rate || product.product_key == ('standard_ipbb_f_1000m')) {
            let extraFeesTotal = product.extra_fees.reduce(function(carry, fee) {
                var feePrice = parseFloat(fee[1]);
                if(feePrice < 0) {
                    return carry;
                }
                carry += feePrice;
                return carry;
            }, 0.00);
            displayPrice += extraFeesTotal;
            productRegularPrice += extraFeesTotal;
        }

        var promo_amount = 0;
        var display_promo_amount = 0;
        var display_promo_duration = 0;
        if (product.promo && product.promo.hasOwnProperty('discount duration')) {
            display_promo_duration = product.promo['discount duration'];
        }
        if(product && product.promo) {
            promo_amount = product.promo['discount amount'];

            // all X month free promos under 1 year should show 10 off the display price
            if(promo_amount == 'free' || promo_amount == '6free' || promo_amount == '4free' || promo_amount == '3free' || promo_amount == '2free') {
                promo_amount = 10;
                display_promo_duration = '12 months';
            }
            else if(promo_amount == '12free') {
                promo_amount = 0;
            } else {
                promo_amount = parseFloat(promo_amount);
            }
        }

        displayPrice =  Number(displayPrice - promo_amount).toFixed(2).replace('.00', '');
        display_promo_amount = Number(promo_amount).toFixed(2).replace('.00', '');

        var access_downstream_speed_display = product.access_downstream_speed;

        var _cardcolclasses = cardcolclasses;
        if(productsCount == 8 && show_voice_only && product.technology == 'ftth') {
            _cardcolclasses = 'col-md-5 col-md-centered';
        }

        var dual_gig_display = false;
        if(
            product.product_key == 'fusion_fiber_business_dual_line_preorder'
            || product.product_key == 'fusion_fiber_business_dual_line'
        ) {
            dual_gig_display = true;
        }
        if(dual_gig_display) {
            access_downstream_speed_display = '2 Gbps';
        }

        access_downstream_speed_display = access_downstream_speed_display == 1000 ? "1,000" : access_downstream_speed_display;
        access_downstream_speed_display = access_downstream_speed_display == 10000 ? "10,000" : access_downstream_speed_display;

        let productcard__body__description_style = (flat_rate_available
            ? {height: '10em'}
            : {}
        );

        let product_header = product.product_name;

        let button_text = (product.product_key.match('preorder')) ? 'Request Fiber Now' : t('common:add_to_cart')

        return (
            <div key={product.product_key} className={_cardcolclasses+" new-product-card"+(dual_gig_display ? ' dualgig-product-card' : '')}>
                <div className="snc-card">
                    {(product_header ? <div className="snc-card__header"><span>{product_header}</span></div> : "")}
                    <div className="snc-card__body">
                        <div className="snc-card__speed-price">
                            <div>
                            <span>{product.guaranteed && !product.product_key.match('_ipbb') && !product.product_key.match('dsl') ? '' : 'Up to '}</span>
                            <span className="lg">{access_downstream_speed_display}</span>
                            {(dual_gig_display ? '' : <span>{t('common:mbps')} at </span>)}
                            </div>

                            {(!dual_gig_display ? '' :
                            <p className="productcard__body__description">
                                {(hide_description
                                    ? false
                                    : t('common:product_descriptions.'+product.product_key.replace('.', '_'))
                                )}
                                {(replace_description_with_eero
                                    ? <img src={store.get('install_path')+"/img/eero-logo.png"} />
                                    : false
                                )}
                            &nbsp;at&nbsp;</p>)}

                            <div>
                                <span className="lg">${displayPrice}</span>
                                <span>/</span>
                                <span>mo</span>
                                {show_price_plus_taxes_fees ? <span className="productcard__price__plus_taxes_fees">+ taxes & fees</span> : ''}
                                {show_price_as_flat_rate ? <span className="productcard__price__flat">flat</span> : ''}
                            </div>
                        </div>

                        {(dual_gig_display ? '' :
                            <div className="snc-card__description" style={productcard__body__description_style}><p>
                                {(hide_description
                                        ? false
                                        : t('common:product_descriptions.'+product.product_key.replace('.', '_'))
                                )}
                                {(replace_description_with_eero
                                        ? <span><img src={store.get('install_path')+"/img/eero-logo.png"} style={{width: '90px', display: 'block', margin: '10px auto 0 auto'}} /><br /><img src={store.get('install_path')+"/img/eero-and-beacon.png"} style={{width: '110px', display: 'block', margin: '5px auto 20px auto'}} /></span>
                                        : false
                                )}
                            </p></div>)}
                                    <hr />
                        {(product.product_key.indexOf('fusion_ipbb_xx') === -1 ? '' :
                        <p className={"productcard__body__description ipbbdelay"}>
                            Please be advised:
                            AT&amp;T is currently experiencing increased delays in delivery of this product,
                            causing longer waits for installation appointments.
                        </p>)}
                        <div className="new-product-card-footer">
                        <a className="snc-btn"
                            onClick={this.selectProduct.bind(null, product)}
                            >{button_text}
                        </a>
                    </div>
                    </div>

                </div>
                <div className="small text-center secretmenu">{product.secret_menu ? t('common:secret_menu') : "\u00a0"}</div>
            </div>
        );
    }
});

export default  translate('common', { wait: true })(ProductLong);
